import { combineReducers } from 'redux'
import drawer from './drawer.reducer'
import auth from './auth.reducer'
import ui from './ui.reducer'
import operation from './operation-setting.reducer'
import integration from './integration.reducer'
import client from './client.reducer'
import posTerminal from './posTerminal.reducer'
import otherModuleAction from './otherModuleAction.reducer'
import locationSetup from './locationSetup.reducer'
import orderQueue from './orderQueue.reducer'
import tenantIdentifierInfo from './tenantIdentifierInfo.reducer'
import receiptTemplate from './receiptTemplate.reducer'
import orderLookup from './orderLookup.reducer'
import breadcrumb from './breadcrumb.reducer'
import tableLayout from './tableLayout.reducer'
import tableService from './tableService.reducer'
import cfd from './cfd.reducer'
import sale from './sell.reducer'

const rootReducer = combineReducers({
    drawer,
    auth,
    ui,
    operation,
    client,
    posTerminal,
    otherModuleAction,
    locationSetup,
    integration,
    orderQueue,
    tenantIdentifierInfo,
    receiptTemplate,
    orderLookup,
    breadcrumb,
    tableLayout,
    tableService,
    cfd,
    sale,
})

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
